// Mock figures for the Dashboard and Overview wireframes. Nothing here is real.

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
/** Months with actual revenue so far (Jan..Sep). */
export const MONTHS_ELAPSED = 9

export type PlanState = "published" | "in_review" | "none"

export interface MarketRow {
  slug: string
  name: string
  currency: string
  revenueThisMonth: number
  changePct: number
  revenueThisYear: number
  /** Null = no published Top Down plan, so no target to compare against. */
  yearTarget: number | null
  needBuying: number
  excessStock: number
  plan: PlanState
}

export const MARKET_ROWS: MarketRow[] = [
  {
    slug: "vietnam", name: "Vietnam", currency: "VND",
    revenueThisMonth: 32_400_000_000, changePct: 9,
    revenueThisYear: 268_000_000_000, yearTarget: 378_000_000_000,
    needBuying: 26, excessStock: 82, plan: "published",
  },
  {
    slug: "intl", name: "International", currency: "USD",
    revenueThisMonth: 412_000, changePct: -4,
    revenueThisYear: 3_150_000, yearTarget: null,
    needBuying: 11, excessStock: 30, plan: "in_review",
  },
]

export const COMPANY = {
  displayCurrency: "USD",
  rateLine: "1 USD = ₫25,999 · Sep 20, 2026",
  revenueThisMonth: 1_658_000,
  changePct: 7,
  revenueThisYear: 13_460_000,
  needBuying: 37,
  excess: { total: 112, overstock: 41, slow: 52, dead: 19 },
}

/** All-markets chart: each market's monthly revenue in the display currency. */
export const COMPANY_MONTHLY = [
  { vietnam: 1_020_000, intl: 310_000 },
  { vietnam: 940_000, intl: 295_000 },
  { vietnam: 1_150_000, intl: 330_000 },
  { vietnam: 1_090_000, intl: 342_000 },
  { vietnam: 1_210_000, intl: 365_000 },
  { vietnam: 1_340_000, intl: 371_000 },
  { vietnam: 1_280_000, intl: 388_000 },
  { vietnam: 1_460_000, intl: 430_000 },
  { vietnam: 1_246_000, intl: 412_000 },
].map((row, i) => ({ label: MONTHS[i], ...row }))

export const PURCHASE_LIST = [
  { label: "Need buying, not on the list yet", value: 37, tone: "warning" as const },
  { label: "On the list, not sent yet", value: 14 },
  { label: "Sent, waiting to arrive", value: 52 },
  { label: "Arrived this month", value: 23 },
]

// ── One market (Vietnam) ────────────────────────────────────────────────────

export const MARKET = {
  currency: "VND",
  revenueThisMonth: 32_400_000_000,
  changePct: 9,
  revenueThisYear: 268_000_000_000,
  yearTarget: 378_000_000_000,
  runningOut: 26,
  excess: { total: 82, overstock: 31, slow: 36, dead: 15 },
}

const ACTUAL = [26.1, 24.3, 29.8, 28.4, 31.2, 34.6, 33.1, 37.9, 32.4]
const PLAN = [27, 25, 28, 29, 30, 33, 34, 36, 35, 38, 42, 45]

export const MARKET_MONTHLY = MONTHS.map((label, i) => ({
  label,
  actual: i < MONTHS_ELAPSED ? ACTUAL[i] * 1_000_000_000 : null,
  plan: PLAN[i] * 1_000_000_000,
}))

export const CHANNELS = [
  { name: "Shopee", revenue: 11_200_000_000 },
  { name: "Tiktok", revenue: 8_700_000_000 },
  { name: "Retail", revenue: 6_500_000_000 },
  { name: "Website", revenue: 3_900_000_000 },
  { name: "Wholesale", revenue: 2_100_000_000 },
]

export const RUNNING_OUT = [
  { name: "Halio Sonic Cleanser — Pink", note: "out in 6 days", urgent: true },
  { name: "Okame Lip Tint 03", note: "out in 9 days", urgent: true },
  { name: "Lustre Sunscreen 50ml", note: "out in 12 days", urgent: true },
  { name: "Halio Whitening Kit", note: "out in 18 days", urgent: false },
  { name: "Okame Cushion N21", note: "out in 20 days", urgent: false },
]

export const MOST_EXCESS = [
  { name: "Lustre Toner 200ml", note: "410 days of stock" },
  { name: "Halio Brush Heads x4", note: "355 days of stock" },
  { name: "Okame Eyeliner Brown", note: "no sales in 90 days" },
  { name: "Gift Box Tet 2026", note: "no sales in 90 days" },
  { name: "Lustre Mask 5-pack", note: "290 days of stock" },
]

export const DATA_UPDATED = [
  { label: "Sales", note: "2 hours ago", stale: false },
  { label: "Warehouse stock", note: "6 hours ago", stale: false },
  { label: "Purchase orders", note: "3 days ago", stale: true },
]
